
import { createSlice } from "@reduxjs/toolkit";
import { getInventorySolarPanel } from "../reduxApi/InventorySolarPanelReduxApi";

const inventorySolarPanelSlice = createSlice({
    name: 'inventorySolarPanel',
    initialState: {
        status: 'idel',
        inventorySolarPanel: [],
    },
    reducers: {
        deleteInventorySolarPanelAction: (state, action) => {
            state.inventorySolarPanel = state.inventorySolarPanel.filter(item => !action.payload.includes(item?.ROWID));


            
        },
        updateInventorySolarPanelAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.inventorySolarPanel.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.inventorySolarPanel.splice(index, 1, action.payload)
    
            }
        },
        addInventorySolarPanelAction: (state, action) => {
            console.log("Adding invertor:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.inventorySolarPanel.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getInventorySolarPanel.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getInventorySolarPanel.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing invertor Data-->", action.payload)
                console.log("testing invertor Data", action.payload.data.inventorySolarPanelResp)
                state.inventorySolarPanel = action.payload.data.inventorySolarPanelResp
;
            })
    }
})
export const { deleteInventorySolarPanelAction, updateInventorySolarPanelAction, addInventorySolarPanelAction } = inventorySolarPanelSlice.actions
export default inventorySolarPanelSlice.reducer